import { render, staticRenderFns } from "./Credito.vue?vue&type=template&id=23f58fed"
import script from "./Credito.vue?vue&type=script&lang=js"
export * from "./Credito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports